<script>
    import Reports from '../../components/Reports.svelte'
</script>
  
  <div class="notifications">
    <div class="columns">
      <div class="column">
        <div class="content">
          <Reports />
        </div>
      </div>
    </div>
  </div>
  